import CrudResource from "@/components/CrudResource";
import { fmtDate } from "@/lib/api";

export default function Assets() {
  return (
    <CrudResource
      title="Manajemen Aset Toko"
      subtitle="Barang inventaris toko (printer, komputer, furnitur, dll) — bukan untuk dijual"
      endpoint="/assets"
      searchable={false}
      totalField={{ key: "purchase_price", label: "Total Nilai Aset" }}
      columns={[
        { key: "name", label: "Nama Aset" },
        { key: "category", label: "Kategori" },
        { key: "purchase_date", label: "Tgl Beli", render: (r) => (r.purchase_date ? fmtDate(r.purchase_date) : "-") },
        { key: "purchase_price", label: "Harga Beli", money: true },
        { key: "condition", label: "Kondisi" },
        { key: "maintenance_schedule", label: "Jadwal Servis" },
      ]}
      fields={[
        { name: "name", label: "Nama Aset", required: true, full: true },
        { name: "category", label: "Kategori", type: "select", default: "Elektronik",
          options: ["Elektronik", "Komputer", "Printer", "Furnitur", "Kendaraan", "Lainnya"] },
        { name: "purchase_date", label: "Tanggal Pembelian", type: "date" },
        { name: "purchase_price", label: "Harga Beli", type: "number" },
        { name: "condition", label: "Kondisi", type: "select", default: "Baik",
          options: ["Baik", "Perlu Perbaikan", "Rusak"] },
        { name: "maintenance_schedule", label: "Jadwal Servis/Maintenance", full: true },
        { name: "note", label: "Catatan", full: true },
      ]}
    />
  );
}
